import React, { useState } from 'react';
import { Workplan } from '@/wpt-lib/interfaces/Workplan';
import CopyWorkplanDialog from '@/components/CopyWorkplan/CopyWorkplanDialog';
import { Button } from '@chakra-ui/react';
import Icons from '@/components/icons/Icons';
import { useAssignment } from '@/components/contexts/AssignmentContext/useAssignment';

const CopyWorkplan = ({ workplan }: { workplan: Workplan }) => {
    const [workplanToCopy, setWorkplanToCopy] = useState<Workplan>();
    const { currentAssignment } = useAssignment();

    return (
        <>
            <Button
                leftIcon={<Icons.CopyIcon />}
                onClick={() => setWorkplanToCopy(workplan)}
                rounded="none"
                variant="outline"
                ml={0}
            >
                Copy Workplan
            </Button>
            {currentAssignment && (
                <CopyWorkplanDialog
                    workplan={workplanToCopy}
                    onClose={() => setWorkplanToCopy(undefined)}
                    currentAssignment={currentAssignment}
                />
            )}
        </>
    );
};

export default CopyWorkplan;
